module.exports = __webpack_public_path__ + "static/img/baoming.b94b789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/baoming.png
// module id = sS5f
// module chunks = 0